import { actions as workspaceActions } from "containers/Workspaces/Workspaces.reducer";
import { Workspace } from "graphql/generated/graphql";
import { Dispatch } from "redux";

interface StoreWorkspaceProps {
    response: Workspace;
    dispatch: Dispatch;
}

export const storeWorkspace = ({ response, dispatch }: StoreWorkspaceProps) =>
    dispatch({
        type: workspaceActions.STORE_WORKSPACE_DATA,
        response: response,
        iri: response.id,
    });

interface CheckBootstrapUserProps {
    name?: string;
    bootstrapUserName?: string;
    recordType?: string;
}

export const checkBootstrapUser = ({
    name,
    bootstrapUserName,
    recordType,
}: CheckBootstrapUserProps) =>
    !!(recordType?.toLowerCase() === "user" && name && bootstrapUserName === name);
